// / <reference path="jquery-1.4.1-vsdoc.js" /> 
(function (sb) {
	var me = (sb.WordCloudCache = {});
	var wordCloudDataCache = {};
	var varCache = {};
	var customColors = {};
	me.setWordCloudDataToCache = function (data, id) {

		wordCloudDataCache[id] = data;
	}
	me.getWordCloudDataFromCache = function (id) {
		return wordCloudDataCache[id];
	}
	me.setVariableToCache = function (variable, id) {
		varCache[id] = variable;
	}
	me.getVariableFromCache = function (id) {
		var cacheInfo = (typeof (varCache[id]) != "undefined") ? varCache[id] : {};
		return cacheInfo;
	}
	me.setColorToCache = function (color, id) {
		customColors[id] = color;
	}
	me.getColorFromCache = function (id) {
		var cacheInfo = (typeof (customColors[id]) != "undefined") ? customColors[id] : "#ffffff";
		return cacheInfo;
	}

})(window.Storyboard = (window.Storyboard || {}));
window.WordCloudSetup = {
	isLoaded: false,
	currentLayoutElementItem: [],
	setupEditPanel: function (contentElement) {
		$("#wcDivPreview").empty().hide();
		WordCloudSetup.currentLayoutElementItem = contentElement;
		$('#wctxtAvailVar').val('');
		if (!WordCloudSetup.isLoaded) {
			Storyboard.Dependency.start('WORDCLOUDSETUP', 'filters');
			Helpers.perfJSonCall({
				method: 'GetFilters',
				message: locale.get('Loading filters'),
				successCallback: function (filters) {
					WordCloudSetup.isLoaded = true;
					WordCloudSetup.bindFilters(filters);
					WordCloudSetup.SetWordCloudSettings(contentElement);
					WordCloudSetup.loadThemesList(10);
					Storyboard.Dependency.complete('WORDCLOUDSETUP', 'filters');
				},
				synchronous: false,
				fixCasing: true
			});
		} else {
			WordCloudSetup.SetWordCloudSettings(contentElement);
			WordCloudSetup.loadThemesList(10);
		}
	},
	redrawWordCloud: function (wordCloudLayoutElementItem) {
		if (wordCloudLayoutElementItem != null) {
			wordCloudLayoutElementItem.content = '';
			$('#' + wordCloudLayoutElementItem.guid).html('');
			if (wordCloudLayoutElementItem.guid != "") {//element already has been saved
				var cloudData = Storyboard.WordCloudCache.getWordCloudDataFromCache(wordCloudLayoutElementItem.guid);
				if ((typeof cloudData != 'undefined') && (cloudData != null)) {
					var wcDiv = $(".layoutElementItem[guid='" + wordCloudLayoutElementItem.guid + "']");
					this.renderWordCloud(wcDiv, cloudData, wordCloudLayoutElementItem.guid);
				}
			}
		}
	},
	loadTabs: function () {
		$("#wordcloudtabholder").tabs("destroy");
		$('#wordcloudtabholder').removeClass('ui-widget');
		$("#wordcloudtabholder").tabs({
			show: function (evt, ui) {
				if (ui.index === 1) {
					$('#wcFilterBox .filterboxHeaderWrapper td').equalHeights();
				}
			}
		});
		$("#wc_layout").find(".ColorTextbox").DUIColorPicker({ layout: 'template' });
	},
	saveSetup: function (layoutElementItem) {
		var leguid = "";
		var wcLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
		leguid = wcLayoutElem.guid;
		//clear wordcloud cache
		Storyboard.WordCloudCache.setWordCloudDataToCache(null, layoutElementItem.guid);
		var wordCloudSettingsData = WordCloudSetup.getWordCloudSettingsData(leguid);
		Helpers.performJSonCall2('SaveWordCloudSettings',
		{
			guid: layoutElementItem.guid,
			layoutElementItemID: layoutElementItem.elementItemId || 0,
			settings: wordCloudSettingsData
		}
			, function (res) {
				var items = [wcLayoutElem];
				Storyboard.LayoutDesigner.loadStorytellerContentForElements(items, true, false, 0, 0, leguid);

				if (res == "OK" && !Storyboard.LayoutDesigner.isUnsaved)
					Storyboard.LayoutDesigner.refreshSlideToplineCompatibility();
			}
		);
	},
	eventUpdateWordCloud: function (layoutElement, wordCloudData) {
		var itemTypes = Storyboard.Constants.itemTypes;
		var wcElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.WORDCLOUD, layoutElement);
		var wcDiv = $(".layoutElementItem[guid='" + wcElem.guid + "']");

		this.renderWordCloud(wcDiv, wordCloudData, wcElem.guid);
	},
	moveItems: function (sender) {
		var id = $(sender).attr("id");
		var selectFrom = id === "wcbtnMoveToSelVar" ? "#wcavailVarBox" : "#wcselectedVarBox";
		var moveTo = id === "wcbtnMoveToAvailVar" ? "#wcavailVarBox" : "#wcselectedVarBox";
		var selectedItems = $(selectFrom + " option:selected");
		var output = [];

		selectedItems.each(function () {
			var $this = $(this);
			var alreadyInList = $(moveTo).find("option[value=" + $this.val() + "]").length > 0;
			if (!alreadyInList)
				output.push(this.cloneNode(true));
		});

		$(moveTo).append(output);

		selectedItems.remove();
	},
	loadFilters: function () {
		Helpers.perfJSonCall({ method: 'GetFilters', successCallback: WordCloudSetup.bindFilters, synchronous: false, fixCasing: true });
	},
	bindFilters: function (filterArray) {
		var template = $("#wcFilterBox > .wcfilterboxTemplate");
		template.show();
		Storyboard.GuiEvents.bindFilters(filterArray, "wcFilterBox", "wcfilterboxTemplate", false);
		Storyboard.GuiEvents.bindOptionalFilters(filterArray, "optFilterBoxWC", "optionFilterTemplateWC", "optionalFilterSettingsWC");
		Storyboard.GuiEvents.bindOptionalFiltersCheckAll("optFilterBoxWC");
		template.hide();

	},
	SetWordCloudSettings: function (contentElement) {
		Storyboard.Dependency.start('WORDCLOUDSETUP', 'settings');
		Helpers.performJSonCall2('GetWordCloudSettings'
			, { guid: contentElement.guid, layoutElementItemID: contentElement.elementItemId || 0 }
			, function (res) {
				WordCloudSetup.loadAllvariables(contentElement, res);
				WordCloudSetup.bindWCSettings(res);
				Storyboard.Dependency.complete('WORDCLOUDSETUP', 'settings');
			}
			, null
			, locale.get('Loading settings'));

	},
	bindWCSettings: function (settings) {
		for (var i in settings.SelectedVariables) {
			settings.SelectedVariables[i].aiIcon = settings.SelectedVariables[i].IsAICompute ? Storyboard.Constants.aiIconEntity : '';
		}

		HTMLHelpers.bindSelect($('#wcselectedVarBox'), settings.SelectedVariables, 'QuestionID', 'QuestionText', false, false, false, false, ["aiIcon", "Code", "QuestionText"]);

		$("#wcselectedVarBox option").each(function () {
			var id = $(this).val();
			var variable = Storyboard.WordCloudCache.getVariableFromCache(id);
			if (variable) {
				$(this).attr('title', HTMLHelpers.htmlDecode(variable.QuestionText));
			}
		});
		if (settings != undefined) {
			$("#wcTimeSelections").find(".tpcDropDown").val(settings.TimePeriod);
			$("#wcTimeSelections").find("#ddlTimePeriodSpan").val(settings.TimePeriodSpan);
			$("#wcTimeSelections").find("#txtTimePeriod").val(settings.TimePeriodSpanAmount);
			if (settings.TimePeriod === 0)
				$("#wcTimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").show();
			else
				$("#wcTimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").hide();
			if (settings.TimePeriod == 27) {
				$("#wcTimeSelections").find("#ddlTimePeriodSpan").show();
				$("#wcTimeSelections").find("#txtTimePeriod").show();
			} else {
				$("#wcTimeSelections").find("#ddlTimePeriodSpan").hide();
				$("#wcTimeSelections").find("#txtTimePeriod").hide();
			}

			if (settings.StartEndPeriod) {
				$("#wcTimeSelections").find(".dateInputStart").datepicker("setDate", Helpers.parseDate(settings.StartEndPeriod.StrStartDate));
				$("#wcTimeSelections").find(".dateInputStop").datepicker("setDate", Helpers.parseDate(settings.StartEndPeriod.StrStopDate));
			} else {
				$("#wcTimeSelections").find(".dateInputStart").datepicker("setDate", Helpers.strToDate($("#wcTimeSelections").find(".dateInputStart").attr("defaultdate")));
				$("#wcTimeSelections").find(".dateInputStop").datepicker("setDate", Helpers.strToDate($("#wcTimeSelections").find(".dateInputStop").attr("defaultdate")));
			}

			$('#wctxtWordNumber').val(settings.WordsNumber);
			$('#wctxtMinChars').val(settings.MinCharsNumber);
			$("#wccbShowWordsCount").attr('checked', Boolean(settings.ShowWordsCount));
			$('#wctxtopendFilter').val(settings.FilterOpenEndedComment);
			$('#ddlDateVarWC').val(settings.DateVariableID === 0 ? $('#ddlDateVarWC').find('option[selected]').val() : settings.DateVariableID);

			WordCloudSetup.setSelectedFilters(settings.Filters);
			WordCloudSetup.setOptionalFilterSettings(settings.OptionalFilterSettings);
			WordCloudSetup.SetWCSVSubsets(settings.VariableSubsets);
			if (!settings.WordCloudStyles || settings.WordCloudStyles.length == 0) {
				var theme = WordCloudStyle.getTemplates()[0].theme;
				var defaultFont = Storyboard.LayoutDesigner.getDefaultFont();
				var stylesArr = $.map(theme.styles, function (style) {
					var keyval = style.split('|');
					if (keyval[0] === "text_font")
						keyval[1] = defaultFont.Family;
					return { SettingKey: keyval[0], SettingValue: keyval[1] };
				});
				WordCloudSetup.setThemesStyles(stylesArr);			
			}
			else {
				WordCloudSetup.setThemesStyles(settings.WordCloudStyles);
			}

			if ($("#ddlDateVarWC option").length <= 1)
				$(".wcDateVar").hide();
			else
				$(".wcDateVar").show();
		}

	},
	SetWCSVSubsets: function (vsArray) {
		WordCloudSetup.ShowHideFilterPanel(vsArray, "#vsWcFilterPanel", "#chkWcVS");
		HTMLHelpers.setSelectedValues('#lbWcVS', vsArray);
		WordCloudSetup.filterVariables();
	},
	ShowHideFilterPanel: function (array, panel, checkbox) {
		if (array && array.length > 0) {
			$(panel).css("display", "inherit");
			$(checkbox).attr("checked", true);
		}
		else {
			$(panel).css("display", "none");
			$(checkbox).attr("checked", false);
		}
	},
	setOptionalFilterSettings: function (optionalFilterSettings) {
		$(".chkOptFilterWC, #chkOptHFilterWC, #chkOptTimePeriodWC, #chkOptVSWC").attr('checked', true);
		if (optionalFilterSettings) {
			optionalFilterSettings.forEach(function(os) {
				if (!os.OptionalSettingType) return;

				if (os.OptionalSettingType == 1)
					$("#chkOptVSWC").attr("checked", os.IsApply);

				if (os.OptionalSettingType == 2) {
					$("#chkOptHFilterWC").attr("checked", os.IsApply);
				}
				else if (os.OptionalSettingType == 3) {
					WordCloudSetup.setOptionalFilterQuestions(os.QuestionID, os.IsApply);
				}
				else if (os.OptionalSettingType == 4) {
					$("#chkOptTimePeriodWC").attr("checked", os.IsApply);
				}
			});
		}

		var allChecked = $('#optionalFilterSettingsWC input[type="checkbox"]')
			.filter(function() { return $(this).attr('id') !== 'chkOptFilter'; })
			.filter(function() { return !$(this).is(':checked'); })
			.length === 0;

		$('#optionalFilterSettingsWC')
			.prev('.optionalFilterSettingsCheckAll').find('input[type="checkbox"]')
			.attr('checked', allChecked);
	},
	setOptionalFilterQuestions: function (questionId, isApply) {
		$("#optFilterBoxWC div").each(function () {
			if (questionId == parseInt($(this).find("#hidOptQuestionId").val() || "0")) {
				$(this).find(".chkOptFilterWC").attr("checked", isApply);
			}
		});
	},
	setSelectedFilters: function (filterArray) {
		HTMLHelpers.setSelectedValues($("#wcFilterBox div select"), 0);
		if (filterArray) {
			filterArray.forEach(function(f) {
				if (!f.FilterID) return;
				var filterbox = $("#wcFilterBox div #hidFilterId[value='" + f.FilterID + "']").parent();

				if (f.AllAnswers)
					HTMLHelpers.setSelectedValues(filterbox.find('select'), "all");
				else {
					var answerIds = $.map(f.Answers, function (e) { return isNaN(e.AnswerID) ? e : e.AnswerID });
					HTMLHelpers.setSelectedValues(filterbox.find('select'), answerIds);
				}
			});
		}
	},
	getFilters: function () {
		var filters = [];

		$("#wcFilterBox > div:not(.wcfilterboxTemplate)").each(function () {
			var filterId = $(this).find("#hidFilterId").val();
			var questionId = $(this).find('#hidQuestionId').val();
			var allAnswers = $(this).find("select option[value='all']:selected").length > 0;

			var selectedAnswers = $(this).find(allAnswers ? "select option" : "select option:selected").
				filter(function () { return $(this).val() != "0" && $(this).val() != "all"; }).
				map(function () {
					return { answerId: $(this).val(), answerText: $(this).text() };
				}).toArray();

			var filterText = $(this).find('h3').text();

			if ($(selectedAnswers).length > 0) {
				var Filter = {
					FilterID: filterId,
					Answers: selectedAnswers,
					Compare: false,
					QuestionID: questionId,
					FilterText: filterText,
					AllAnswers: allAnswers
				};

				filters.push(Filter);
			}
		});

		return filters;
	},
	bindThemesList: function (themeArray) {
		$('#WordCloudThemesTemplateList').empty();
		for (var index in themeArray)
			if (themeArray.hasOwnProperty(index)) {

				var theme = $('<div class="ThemePreview"><img src="' +
				Storyboard.Constants.wordCloudTemplateImageFolderPath + themeArray[index].theme.id + '.png" alt="' +
				themeArray[index].theme.name + '" title="' + themeArray[index].theme.name + '" themeID="' + themeArray[index].theme.id + '" /></div>')
						.click(function (evt) {
							evt.preventDefault();
							evt.stopPropagation();

							WordCloudSetup.setThemesStyles(themeArray[$(evt.target).attr('themeid')].theme.styles);
						});
				$('#WordCloudThemesTemplateList').append(theme);
			}
	},
	loadThemesList: function (howMany) {
		WordCloudSetup.bindThemesList(WordCloudStyle.getTemplates());
		/*
        Helpers.performJSonCall2('GetWordCloudThemesList'
			, { themesCount: howMany }
			, function (res) { WordCloudSetup.bindThemesList(res); }
                        );
        */
	},
	getWCThemeStyles: function (themeID, callback) {
		var data = {
			themeID: themeID
		}
		Helpers.perfJSonCall({ method: "GetWordCloudThemeStyles", data: data, successCallback: callback, fixCasing: false });
	},
	setThemesStyles: function (styleArray) {
		if (!(styleArray == null || styleArray.length == 0)) {
			//first search custom colors number value to create custom palette table
			styleArray.forEach(function (style) {
				var wcKV, wcKey, wcVal;
				if (style.SettingKey === undefined) {
					wcKV = style.split('|');
					wcKey = wcKV[0];
					wcVal = wcKV[1];
				} else {
					wcKey = style.SettingKey;
					wcVal = style.SettingValue;
				}

				var ddl = '#wc_' + wcKey;
				if (ddl == "#wc_customcolorsnumber") {
					if ((wcVal != '') && (wcVal != '0')) {
						$(ddl).val(wcVal);
						$("#wc_usecustompalette").attr('checked', 'checked');
						WordCloudSetup.ShowCustomPaltette();
					}
					else {
						$("#wcrandomcolor").attr('checked', 'checked');
						WordCloudSetup.HideCustomPaltette();
					}
				}
			});
			styleArray.forEach(function (style) {
				var wcKV, wcKey, wcVal;
				if (style.SettingKey === undefined) {
					wcKV = style.split('|');
					wcKey = wcKV[0];
					wcVal = wcKV[1];
				} else {
					wcKey = style.SettingKey;
					wcVal = style.SettingValue;
				}

				var selector = '#wc_' + wcKey;
				var elem = selector.replace('_colorPlaceholderId', '');
				var color, colorId;

				if ($(elem).is('input:text') && wcVal != '') {
					if ($(elem).hasClass('colorpicker-target')) {
						// Colorpicker
						if (~wcKey.indexOf('_colorPlaceholderId')) {
							colorId = wcVal;
							color = styleArray.find(function(style) { return style.SettingKey === wcKey.replace('_colorPlaceholderId', ''); });
							color = color ? color.SettingValue : null;
						} else {
							colorId = styleArray.find(function(style) { return style.SettingKey === wcKey + '_colorPlaceholderId'; });
							colorId = colorId ? colorId.SettingValue : null;
							color = wcVal;
						}

						$(elem).DUIColorPicker({
							layout: 'template',
							selected: {
								colorString: color,
								templateColorId: colorId
							}
						});
					} else {
						// Textbox
						$(elem).val(wcVal);
					}
					$(elem).change();
				}
				else if ($(elem).is('input:checkbox')) {
					// Checkbox
					$(elem).attr('checked', (wcVal == 'True') ? 'checked' : '');
				}
				else if ($(elem).is('select') && wcVal != '') {
					// Dropdownlist 
					if (wcVal.includes(",") && style.SettingKey === "text_font") {
						var sv = wcVal.split(',')[0];
						$(elem).val(sv);
					}
					else {
						$(elem).val(wcVal);
					}
				}
				else if ($(elem).is('input:radio')) {
					// Radiobutton
					if (elem == "#wc_usecustompalette") {
						var isCustomPalette = wcVal == 'True';
						$(elem).attr('checked', isCustomPalette ? 'checked' : '');
						$("#wcrandomcolor").attr('checked', !isCustomPalette ? 'checked' : '');
						if (isCustomPalette) {
							$('#wccolorsnumrow').show();
						}
						else {
							$('#wccolorsnumrow').hide();
						}
					}
				}
			}); // forEach
		}
	},
	getStyles: function () {
		var dict = [];
		var styleDiv = $("#wc_layout");
		var styleList = $(styleDiv).find("[id^=wc_]");
		$(styleList).each(function (index) {
			var dictItem = {};
			var key = $(this).attr("id").substring(3);
			dictItem.SettingKey = key;
			if ($(this).is('input:text')) {
				//skip template control
				if (!$(this).hasClass("ColorTextboxTemplate")) {
					dictItem.SettingValue = $(this).attr("title");
					if (dictItem.SettingValue == "") {
						dictItem.SettingValue = "#000000";
					}
				}

			}
			else if ($(this).is('input:checkbox')) {
				dictItem.SettingValue = $(this).is(':checked');
			}
			else if ($(this).is('input:radio')) {
				dictItem.SettingValue = $(this).is(':checked');
			}
			else if ($(this).is('select') || $(this).is('input:hidden')) {
				dictItem.SettingValue = $(this).val();
				if (($(this).hasClass("wccustomcolorsnumber")) && (!$("#wc_usecustompalette").is(':checked'))) {
					dictItem.SettingValue = "0";
				}
				if (dictItem.SettingKey === "text_font") {
					dictItem.SettingValue = Storyboard.LayoutDesigner.UserEvents.getFontStackByFontFamily(dictItem.SettingValue);
				}
			}
			if (dictItem.SettingValue != undefined && dictItem.SettingValue != null) {
				dict.push(dictItem);
			}

			// Create template color setting
			if ($(this).hasClass('colorpicker-target') && $(this).DUIColorPicker('get.selectedColorId')) {
				var dictPlaceholder = {
					SettingKey: 	key + '_colorPlaceholderId',
					SettingValue: 	$(this).DUIColorPicker('get.selectedColorId')
				};
				if (dictPlaceholder.SettingValue != undefined && dictPlaceholder.SettingValue != null) {
					dict.push(dictPlaceholder);
				}
			}
		});
		return dict;
	},

	GetTemplateData: function (templateId, callback, templateElementItemId) {
		var data = {
			templateDataGroupId: templateElementItemId,
			templateId: templateId
		};

		Helpers.perfJSonCall({
			method: "TemplateDataGroupData", data: data,
			successCallback: function (result) { callback(result); },
			fixCasing: true
		});
	},

	BindTemplateData: function (templateData) {
		if (templateData.length === 0) {
			$('#wizardWordCloud .dataSection').hide();
			$('#wizardWordCloudVariables').closest('fieldset').removeClass('expandable').addClass('collapsable');
			return;
		}
		$("#wcTemplateQA").empty();
		$("#wcTemplateFilters").empty();
		for (var i = 0; i < templateData.length; i++) {
			if (templateData[i].isWizard) {
				if (templateData[i].type.includes("wcQnA") || templateData[i].type.includes("wcQA"))
					$("#wcTemplateQA").append('<li>' + templateData[i].data + '</li>');
				else if (templateData[i].type.includes("Filter"))
					$("#wcTemplateFilters").append('<li>' + templateData[i].data + '</li>');
			}
		}
	},

	loadAllvariables: function (contentElement, settings) {
		Helpers.performJSonCall2('LoadAllOpenEndedVariables'
			, null
			, function (res) {
				$.each(res, function () {
					WordCloudSetup.setVaraibleToCache(this, this.QuestionID);
				});
				WordCloudSetup.loadAvailOEVariables(res);
				if (contentElement.templateId != null)
					WordCloudSetup.GetTemplateData(contentElement.templateId, function (data) {
						WordCloudSetup.BindTemplateData(data);
					}, settings.TemplateElementItemId);
				//bindRTSettings should calls only after all variables are loaded
				WordCloudSetup.bindWCSettings(settings);
			}
			, null
			, locale.get('Loading variables'));

	},
	setVaraibleToCache: function (variable, id) {
		Storyboard.WordCloudCache.setVariableToCache(variable, id);
	},
	loadAvailOEVariables: function (settingsList) {
		for (var i in settingsList) {
			settingsList[i].aiIcon = settingsList[i].IsAICompute ? Storyboard.Constants.aiIconEntity : '';
		}

		HTMLHelpers.bindSelect($("#wcavailVarBox"), settingsList, "QuestionID", "QuestionText", false, false, false, false, ["aiIcon", "Code", "QuestionText"]);
		
		if ($("#chbWCShowQuestionCode").is(":checked"))
			HTMLHelpers.resetOptionsTexts($("#wcavailVarBox"), ["Code", "QuestionText"], " - ");

		Storyboard.LayoutControls.showLoadingBar('Loading variables');
		$("#wcavailVarBox option").each(function () {
			var id = $(this).val();
			var variable = Storyboard.WordCloudCache.getVariableFromCache(id);
			if (variable) {
				$(this).attr('title', HTMLHelpers.htmlDecode(variable.QuestionText));
			}
		});
		Storyboard.LayoutControls.hideLoadingBar();
		WordCloudSetup.clearMovedVariables();
	},
	clearMovedVariables: function () {
		$("#wcselectedVarBox option").each(function (opt) {
			var option = $("#wcselectedVarBox option").eq(opt);
			$('#wcavailVarBox option[value="' + option.attr("value") + '"]').remove();
		});
	},
	getWordCloudSettingsData: function (layoutElementGuid) {
		var data = {};
		if (layoutElementGuid != undefined && layoutElementGuid != "") {
			var le = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementGuid);
			var leItem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.WORDCLOUD, le);
			data.LayoutElementItemGuid = leItem.guid;
			//will be set to the layoutElementId on the server side
			data.SettingId = leItem.layoutElementId;
		}
		else {
			data.LayoutElementItemGuid = "";
			data.SettingId = 0;
		}
		data.SelectedVariables = WordCloudSetup.getSelectedVariables();
		data.TimePeriod = WordCloudSetup.getTimePeriod().timePeriod;
		data.TimePeriodSpan = WordCloudSetup.getTimePeriod().timePeriodSpan;
		data.TimePeriodSpanAmount = WordCloudSetup.getTimePeriod().timePeriodSpanAmount;
		data.StartEndPeriod = WordCloudSetup.getStartEndPeriod();
		data.Filters = WordCloudSetup.getFilters();
		data.OptionalFilterSettings = WordCloudSetup.getOptionalFilterSetting(data.SettingId);
		data.VariableSubsets = WordCloudSetup.getVarSubs();
		data.WordCloudStyles = WordCloudSetup.getStyles();
		data.WordsNumber = $('#wctxtWordNumber').val();
		data.MinCharsNumber = $('#wctxtMinChars').val();
		data.ShowWordsCount = $("#wccbShowWordsCount").is(':checked');
		data.FilterOpenEndedComment = $('#wctxtopendFilter').val();
		data.DateVariableID = $('#ddlDateVarWC').val() || 1;

		return data;
	},
	getVarSubs: function () {
		return $('#lbWcVS').val() || [];
	},

	getOptionalFilterSetting: function (settingId) {
		var optFilterSettings = [];
		var rowVS = new Object();
		rowVS.SettingId = parseInt(settingId || "0");
		rowVS.OptionalSettingType = 1;
		rowVS.IsApply = $("#chkOptVSWC").is(":checked");
		optFilterSettings.push(rowVS);

		var rowHFilter = new Object();
		rowHFilter.SettingId = parseInt(settingId || "0");
		rowHFilter.OptionalSettingType = 2;
		rowHFilter.IsApply = $("#chkOptHFilterWC").is(':checked');
		optFilterSettings.push(rowHFilter);

		$("#optFilterBoxWC div").each(function () {
			var rowFilter = new Object();
			rowFilter.SettingId = parseInt(settingId || "0");
			rowFilter.FilterID = parseInt($(this).find("#hidOptFilterId").val() || "0");
			rowFilter.QuestionID = parseInt($(this).find("#hidOptQuestionId").val() || "0");
			rowFilter.OptionalSettingType = 3;
			rowFilter.IsApply = $(this).find('.chkOptFilterWC').is(':checked');
			if (rowFilter.FilterID > 0)
				optFilterSettings.push(rowFilter);
		});

		var rowTimePeriod = new Object();
		rowTimePeriod.SettingId = parseInt(settingId || "0");
		rowTimePeriod.OptionalSettingType = 4;
		rowTimePeriod.IsApply = $("#chkOptTimePeriodWC").is(':checked');
		optFilterSettings.push(rowTimePeriod);

		return optFilterSettings;
	},
	getSelectedVariables: function () {
		var variables = [];
		var selQuest = $('#wcselectedVarBox option');
		selQuest.each(function () {
			var variable = {};
			variable.AnswerBlockID = 0;
			variable.QuestionID = this.value;
			variable.QuestionText = this.text;
			variable.Title = this.text;
			variable.QuestionT = 0;
			variable.IsReportActive = false;
			variable.Answers = [];
			variables.push(variable);
		})
		return variables;
	},
	getTimePeriod: function () {
		var timePeriodObject = {};
		timePeriodObject.timePeriod = $("#wcTimeSelections").find(".tpcDropDown").val() || 0;
		timePeriodObject.timePeriodSpan = $("#wcTimeSelections").find("#ddlTimePeriodSpan").val() || 1;
		timePeriodObject.timePeriodSpanAmount = $("#wcTimeSelections").find("#txtTimePeriod").val() || 0;
		return timePeriodObject;
	},
	getStartEndPeriod: function () {
		var timeStartEnd = {};
		timeStartEnd.startDate = Helpers.formatDate($("#wcTimeSelections").find('.dateInputStart').datepicker('getDate'));
		timeStartEnd.stopDate = Helpers.formatDate($("#wcTimeSelections").find('.dateInputStop').datepicker('getDate'));
		return timeStartEnd;
	},
	filterVariables: function () {
		var filter = $('#wctxtAvailVar').val();
		WordCloudSetup.getFilterVariables(filter, WordCloudSetup.loadAvailOEVariables);
	},
	getFilterVariables: function (filter, callback) {
		var data = {
            filterText: filter,
			filterByCode: $("#chbWCShowQuestionCode").attr("checked"),
			variableSubsets: WordCloudSetup.getVarSubs()
		}
		Helpers.perfJSonCall({ method: "FilterOpenEndedVariables", data: data, successCallback: callback, fixCasing: false });
	},
	renderWordCloud: function (wcDiv, wordCloudData, elementItemGuid) {
		var slideID;
		$(wcDiv).empty();
		Storyboard.WordCloudCache.setWordCloudDataToCache(wordCloudData, elementItemGuid);
		if (wordCloudData == null || wordCloudData.DataContent == null) {
			if (Storyboard.LayoutDesigner.useNewNoDataLayout) {
				$(wcDiv).removeClass("layoutElementWordCloud").addClass("layoutElementNoDataText")
					.html($('<span/>', { 'class': 'noData', html: locale.get('no data') }))
					.css({ 'background-image': '' });
			} else {
				$(wcDiv).html("No Data");
			}
			if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
				slideID = $(wcDiv).closest(".layoutSlide").attr('slideid');
				if (slideID) {
					var slide = Storyboard.LayoutDesigner.getSlideById(slideID);
					Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
				}
			}
		} else {
			//clear background image
			$(wcDiv).removeClass("layoutElementNoDataText")
					.addClass("layoutElementWordCloud")
					.css("background", "#fff");
			if (wordCloudData.StyleBckgColor != '') {
				$(wcDiv).css("background-color", wordCloudData.StyleBckgColor);
			}

			// if slide is hidden, words will not be positioned correctly. gotta hack it =_=
			var hidden = $(wcDiv).closest(".layoutSlide").hasClass("hidden");
			var slideEl = $(wcDiv).closest(".layoutSlide");
			slideID = $(slideEl).attr('slideid');
			var element = $(wcDiv).closest(".layoutElement");
			var elementTop = element.css("top");
			if (hidden) {
				element.css("top", "-9999px").detach().appendTo("body");
			}
			$(wcDiv).jQCloud(wordCloudData.DataContent, {
				delayedMode: false,
				afterCloudRender: function () {
					if (hidden) {
						element.css("top", elementTop).detach().appendTo(slideEl);
					}

					if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen() && slideID) {
						var slide = Storyboard.LayoutDesigner.getSlideById(slideID);
						Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
					}
				}
			});
		}
		$(wcDiv).show();
		Storyboard.LayoutControls.hideLoadingBar();
	},
	ShowCustomPaltette: function () {
		var colorsNum = 0;
		if ($("#wc_usecustompalette").is(':checked')) {
			colorsNum = parseInt($("#wc_customcolorsnumber").val());
			if (isNaN(colorsNum)) {
				colorsNum = 0;
			}
		}
		if (colorsNum > 0) {
			WordCloudSetup.SetColorsToCache();
			//remove previous table
			$("#tblwcColorsDefs  .wcDataRow:not('.wcRowtemplate')").remove();
			//get row template
			var template = $("#tblwcColorsDefs  .wcRowtemplate");
			var table = $("#tblwcColorsDefs");
			template.show();
			for (var i = 1; i <= colorsNum; i++) {
				var colorValue = Storyboard.WordCloudCache.getColorFromCache(i);
				var newRow = $(".wcRowtemplate").clone();
				newRow.removeClass("wcRowtemplate");
				var colorTextBox = newRow.find(".ColorTextboxTemplate");
				colorTextBox.attr("id", "wc_customcolor" + i);
				colorTextBox.addClass("ColorTextbox").removeClass("ColorTextboxTemplate");
				colorTextBox.val(colorValue);
				colorTextBox.css('background', '');
				var normValue = (colorValue.toLowerCase().replace(/ /g, '').indexOf('(255,255,255,0') > -1) ? 'transparent' : colorValue;
				colorTextBox.css('background-color', normValue);
				colorTextBox.attr('title', normValue);

				newRow.find(".wccolorid").text("Color " + i);
				newRow.find(".wcRownr").val(i);
				table.append(newRow);
			}
			template.hide();
			$("#pnlcustompalette").show();
			table.find(".ColorTextbox").DUIcolorPicker({ layout: 'template' });
		}
		else {
			WordCloudSetup.HideCustomPaltette();
		}
	},
	HideCustomPaltette: function () {
		WordCloudSetup.SetColorsToCache();
		$("#pnlcustompalette").hide();
		//remove colors table
		$("#tblwcColorsDefs  .wcDataRow:not('.wcRowtemplate')").remove();
	},
	SetColorsToCache: function () {
		var defRows = $("#tblwcColorsDefs  .wcDataRow:not('.wcRowtemplate')");
		defRows.each(function () {
			var rowNr = $(this).find(".wcRownr").val();
			var colorValue = $(this).find("[id^=wc_customcolor]").attr("title");
			Storyboard.WordCloudCache.setColorToCache(colorValue, rowNr);
		});
	},
	showPreview: function () {
		var previewDiv = $("#wcDivPreview").empty();
		previewDiv.css("width", WordCloudSetup.currentLayoutElementItem.width);
		previewDiv.css("height", WordCloudSetup.currentLayoutElementItem.height);
		var filterSettings = GeneralSettings.getSelectedSettings();
		var leguid = "";
		var wcLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByElementItem(WordCloudSetup.currentLayoutElementItem);
		leguid = wcLayoutElem.guid;
		//clear wordcloud cache
		Storyboard.WordCloudCache.setWordCloudDataToCache(null, WordCloudSetup.currentLayoutElementItem.guid);
		var settingsData = WordCloudSetup.getWordCloudSettingsData(leguid);

		Storyboard.LayoutControls.showLoadingBar('Loading data...');
		Helpers.performJSonCall2('getWordCloudData'
			, {
				settings: settingsData,
				generalSettings: filterSettings
			}
			, function (wordCloudData) {
				WordCloudSetup.renderWordCloud(previewDiv, wordCloudData, WordCloudSetup.currentLayoutElementItem.guid);
			});
	},
	initWizard: function (templateId) {
		var $setup = $('#setupWordCloudTab');

		// Append controls to Wizard
		$('#wizardWordCloudVariables').append($setup.find('#wc_variables .settingsFieldsetContent'));
		$('#wizardWordCloudFilters').append($setup.find('#wcFilterBox'));
		$('#wizardWordCloudTime').append($setup.find('#wcTimeSelections').removeClass('settingsFieldsetContent'));
		$('#wizardWordCloudPreview').append($setup.find('#wcDivPreview'));

		$('#wizardWordCloudVariables .availVarBox, #wizardWordCloudVariables .selectedVarBox').addClass('size-1-2');

		$('#wizardWordCloudPreviewButton').unbind('click.setupWizard').bind('click.setupWizard', WordCloudSetup.showPreview);

		// Hide
		$setup.find('#wordcloudtabholder').css('display', 'none');
		$('#DUI-ST-MULTIEDIT').css('display', 'none');
		$('#wizardWordCloud').css('display', '').find('.tabs + .expandable > .settingsFieldsetLegend').trigger('click');
		$('#setupHolder').addClass('setupWizard');

		// Template Data
		if (templateId != null) {
			$('#wizardWordCloud .dataSection').show();
			$('#wizardWordCloudVariables').closest('fieldset').removeClass('collapsable').addClass('expandable');
		}
		else {
			$('#wizardWordCloud .dataSection').hide();
			$('#wizardWordCloudVariables').closest('fieldset').removeClass('expandable').addClass('collapsable');
		}
	},
	destroyWizard: function () {
		var $setup = $('#setupWordCloudTab');

		if ($('#wordcloudtabholder > .tabs .setupWizardInit').length === 0) {
			$setup.find('#wordcloudtabholder > .tabs').prepend('<li class="ui-state-default setupWizardInit"><a>Wizard</a></li>');
			$('#wordcloudtabholder > .tabs .setupWizardInit').bind('click', WordCloudSetup.initWizard);
		}

		$('#wizardWordCloudVariables .availVarBox, #wizardWordCloudVariables .selectedVarBox').removeClass('size-1-2');

		// Append controls to chart setup
		$setup.find('#wc_variables').append($('#wizardWordCloudVariables .settingsFieldsetContent'));
		$setup.find('#wc_filters .settingsFieldset:first-child .settingsFieldsetLegend + .settingsFieldsetContent')
				.append($('#wizardWordCloudFilters #wcFilterBox'));
		$setup.find('#wc_settings .settingsFieldset:first-child').append($('#wcTimeSelections').addClass('settingsFieldsetContent'));
		$setup.find('.preview-groupings > div').append($setup.find('#wcDivPreview'));

		$setup.find('#wordcloudtabholder, #DUI-ST-MULTIEDIT').css('display', '');
		$('#DUI-ST-MULTIEDIT').css('display', 'none');
		$('#wizardWordCloud').css('display', 'none');
		$('#setupHolder').removeClass('setupWizard');
	},
	removeWizard: function () {
		if ($('#setupHolder').hasClass('setupWizard')) WordCloudSetup.destroyWizard();
		$('#wordcloudtabholder > .tabs .setupWizardInit').remove();
	},
	hideFilterPanelWC: function (sender, id) {
		if (!$(sender).attr("checked")) {
			$("#" + id).slideUp('fast');
			$("#" + id).find("select>option").removeAttr("selected");
			WordCloudSetup.filterVariables();
		}
		else {
			$("#" + id).slideDown('fast');
		}
	}
};